/**
 * @param {Id} externalId
 * @param {Id} sourceId
 * @param {FavoriteImage} fav
 * @returns {boolean}
 */
export const isMediaRelatedToFav = (externalId, sourceId, fav) => {
    return fav.external_id == externalId && fav.source_id === sourceId;
};
